import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'quotaholdersoperations',
    path: '/quotaholdersoperations',
    component: () => import(/* webpackChunkName: "quotaholdersoperations" */ '../components/quotaholdersoperations/QuotaholdersOperationsView.vue'),
  },
] as RouteConfig[];
